<template>
	<div class="flow-timeseries-tooltip">
		<div class="flow-t-tooltip-title">
			{{ formatTitle(title) }}
		</div>
		<div
			v-for="(p, index) in points"
			:key="p.index + p.name + index"
			class="flow-t-tooltip-name-value"
		>
			<span class="flow-t-tooltip-point-name text-ellipsis">{{ p.name }}</span>
			<span class="flow-t-tooltip-point-value" :style="'color:' + p.color">{{ p.value }}</span>
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import moment from "moment";

export default defineComponent({
	name: "TimeseriesTooltip",
	methods: {
		formatTitle(date) {
			return moment(date).format("DD-MM-YYYY | hh:mm:ss A");
		}
	}
});
</script>
<style lang="scss">
div.flow-timeseries-tooltip {
	display: flex;
	flex-direction: column;

	background: rgba(0, 0, 0, 0.9);
	color: #fff;
	min-width: 200px;
	max-width: 300px;
	padding: 4px;
	font-family: inherit;
	font-size: 10px;
	border-radius: 4px;

	> div.flow-t-tooltip-title {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		font-size: 10px;
		line-height: 10px;
		margin-bottom: 4px;
	}
	> div.flow-t-tooltip-name-value {
		display: flex;
		align-items: center;
		justify-content: space-between;

		> span.flow-t-tooltip-point-value {
			font-weight: bold;
			font-size: 14px;
			white-space: nowrap;
			line-height: 14px;
			margin-left: 16px;
		}
	}
}
</style>
